import { render, staticRenderFns } from "./DeleteStaffModal.vue?vue&type=template&id=4c4afc22"
import script from "./DeleteStaffModal.vue?vue&type=script&lang=js"
export * from "./DeleteStaffModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteStaffModal.vue?vue&type=style&index=0&id=4c4afc22&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4afc22')) {
      api.createRecord('4c4afc22', component.options)
    } else {
      api.reload('4c4afc22', component.options)
    }
    module.hot.accept("./DeleteStaffModal.vue?vue&type=template&id=4c4afc22", function () {
      api.rerender('4c4afc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/DeleteStaffModal.vue"
export default component.exports